<template>
  <div class="info-box" :class="classList">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'info-box',
  props: ['variant', 'no-margin'],
  data() {
    return {
      classList: [],
    };
  },
  mounted() {
    this.classList.push(`info-box--${this.variant}`);
    if (this.noMargin) {
      this.classList.push('info-box--no-margin');
    }
  },
};
</script>

<style lang="scss" scoped>
.info-box {
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background: color('background');
  text-align: center;

  &--no-margin {
    margin: 0;
  }

  &--primary {
    color: color('primary', 'text');
    background: color('primary');
  }

  &--info {
    color: rgba(255, 255, 255, 0.9);
    background: color('denotive', 'info');
  }

  &--warning {
    color: rgba(0, 0, 0, 0.9);
    background: color('denotive', 'warning');
  }
}
</style>
